import React from "react"
import { FaBars } from "react-icons/fa"
import { useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"

import classes from "./CashManagmentTopbar.module.scss"
import clsx from "clsx"

const CashManagmentTopbar = props => {
  const { setOpenCashManagmentSidebar } = props

  const [t, i18n] = useTranslation()

  const history = useHistory()

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["container"]}>
      <button
        id="cash-managment-sidebar-hamburger-button"
        className={clsx(classes["button"], isLtr && classes["button-ltr"])}
        onClick={() => setOpenCashManagmentSidebar(prev => !prev)}
      >
        <FaBars
          size={20}
          color="white"
        />
      </button>

      <button
        className={clsx(classes["back"], isLtr && classes["back-ltr"])}
        onClick={() => history.goBack()}
      >
        {t("بازگشت")}
      </button>
    </div>
  )
}

export default CashManagmentTopbar